// components/SelfPaced/ModuleCard.js
// Matches REPLIT collapsible module card design
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import {
  Plus, Edit, Trash2, MoreVertical, ChevronDown, ChevronRight, GripVertical, Lock,
} from 'lucide-react';
import { AppButton } from '../ui';
import LessonItem from './LessonItem';
import './_self-paced-pages.scss';

const CRITERIA_LABELS = {
  previous_complete: 'Complete previous module',
  previous_quiz_passed: 'Pass previous quiz',
  none: 'No restriction',
};

const ModuleCard = ({
  module: mod,
  index,
  isExpanded,
  sequential,
  onToggle,
  onEdit,
  onDelete,
  onAddLesson,
  onEditLesson,
  onDeleteLesson,
  onConfirmUpload,
  onPreviewLesson,
  onTriggerAI,
  aiTriggeringId,
}) => {
  const lessonCount = mod.lessons?.length || 0;
  const showLockBadge = sequential && mod.unlockCriteria && mod.unlockCriteria !== 'none';

  return (
    <div className="sp-module-card">
      {/* Module Header — collapsible trigger */}
      <div className="sp-module-header" onClick={onToggle}>
        <div className="sp-module-header__left">
          <GripVertical size={16} className="sp-module-header__grip" />
          {isExpanded
            ? <ChevronDown size={16} className="sp-module-header__chevron" />
            : <ChevronRight size={16} className="sp-module-header__chevron" />
          }
          <div>
            <h4 className="sp-module-header__title">{mod.title}</h4>
            <p className="sp-module-header__meta">
              {lessonCount} lesson{lessonCount !== 1 ? 's' : ''}
              {showLockBadge && (
                <span className="sp-module-header__lock-badge">
                  <Lock size={12} /> {CRITERIA_LABELS[mod.unlockCriteria]}
                </span>
              )}
            </p>
          </div>
        </div>

        <Dropdown align="end" onClick={(e) => e.stopPropagation()}>
          <Dropdown.Toggle as="button" className="app-btn app-btn--ghost app-btn--icon">
            <MoreVertical size={16} />
          </Dropdown.Toggle>
          <Dropdown.Menu
            renderOnMount
            popperConfig={{
              strategy: 'fixed',
              modifiers: [{ name: 'preventOverflow', options: { boundary: 'viewport' } }],
            }}
          >
            <Dropdown.Item onClick={onEdit}>
              <Edit size={14} /> Edit Module
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item className="text-danger" onClick={onDelete}>
              <Trash2 size={14} /> Delete Module
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Lessons */}
      {isExpanded && (
        <>
          <div className="sp-module-lessons">
            {lessonCount === 0 ? (
              <div className="sp-lesson-item" style={{ justifyContent: 'center' }}>
                <span style={{ color: 'hsl(var(--muted-foreground))', fontSize: '0.875rem' }}>
                  No lessons yet.
                </span>
              </div>
            ) : (
              mod.lessons.map((lesson) => (
                <LessonItem
                  key={lesson._id}
                  lesson={lesson}
                  onEdit={() => onEditLesson(lesson)}
                  onDelete={onDeleteLesson}
                  onConfirmUpload={onConfirmUpload}
                  onPreview={onPreviewLesson}
                  onTriggerAI={onTriggerAI}
                  aiTriggeringId={aiTriggeringId}
                />
              ))
            )}
          </div>
          <div className="sp-module-footer">
            <AppButton variant="ghost" size="sm" onClick={onAddLesson}>
              <Plus size={14} /> Add Lesson
            </AppButton>
          </div>
        </>
      )}
    </div>
  );
};

export default ModuleCard;
